import { render, staticRenderFns } from "./CfdeSingleSearch.vue?vue&type=template&id=60a65204&scoped=true"
import script from "./CfdeSingleSearch.vue?vue&type=script&lang=js"
export * from "./CfdeSingleSearch.vue?vue&type=script&lang=js"
import style0 from "./CfdeSingleSearch.vue?vue&type=style&index=0&id=60a65204&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a65204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a65204')) {
      api.createRecord('60a65204', component.options)
    } else {
      api.reload('60a65204', component.options)
    }
    module.hot.accept("./CfdeSingleSearch.vue?vue&type=template&id=60a65204&scoped=true", function () {
      api.rerender('60a65204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/CfdeSingleSearch.vue"
export default component.exports